import { render, staticRenderFns } from "./other-names.vue?vue&type=template&id=20daa1b8&"
import script from "./other-names.vue?vue&type=script&lang=js&"
export * from "./other-names.vue?vue&type=script&lang=js&"
import style0 from "./other-names.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports